export default __webpack_public_path__ + "static/media/settings.5b143948.svg";